export const RECIPE_STEP_1 = 0;
export const RECIPE_STEP_2 = 1;
export const RECIPE_STEP_3 = 2;

const steps = {
  [RECIPE_STEP_1]: {
    component: () =>
      import(
        /* webpackChunkName: "conduct-stocktake" */ '@/views/platform/venue/recipes/new/Info.vue'
      ),
    title: 'Info',
    pageTitle: 'Add New',
    pageTitleUpdate: 'Update',
    pageInfo: 'Set the output quantity and unit for your ingredient, recipe or menu item.',
    nextCta: 'Next Step',
  },
  [RECIPE_STEP_2]: {
    component: () =>
      import(
        /* webpackChunkName: "conduct-stocktake" */ '@/views/platform/venue/recipes/new/Products.vue'
      ),
    title: 'Products',
    pageTitle: 'And now select products',
    pageInfo: 'Select products that will be included in this recipe.',
    pageInfoIngredient:
      'Select products that can be used as this ingredient and add their conversions.',
    nextCta: 'Go To Overview',
  },
  [RECIPE_STEP_3]: {
    component: () =>
      import(
        /* webpackChunkName: "conduct-stocktake" */ '@/views/platform/venue/recipes/new/Overview.vue'
      ),
    title: 'Overview',
    pageTitle: 'Overview',
    nextCta: 'Add New Recipe',
    nextCtaUpdate: 'Update Recipe',
  },
};

export default steps;
